import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import NotFound from './pages/NotFound';
import Visa from "./pages/Visa";
import Blog from "./pages/Blog";
import BlogDetails from "./pages/BlogDetails";
import VisaByType from "./pages/VisaByType";
import VisaDetails from "./pages/VisaDetails";
import Contact from "./pages/Contact";
import Layout from "./Layout";
import ScrollToTopButton from './component/ScrollToTopButton';
import ScrollToTop from './component/ScrollToTop.jsx';
import Faq from "./pages/Faq";

function App() {
  return (
      <>
          <BrowserRouter>
              <ToastContainer />
              <ScrollToTop />
              <Routes>
                  <Route path="/" element={<Layout />}>
                      <Route index element={<Home />} />
                      <Route path="about-us" element={<About />} />
                      <Route path="blogs" element={<Blog />} />
                      <Route path="blog/details/:slug" element={<BlogDetails />} />
                      <Route path="visa" element={<Visa />} />
                      <Route path="visa/:slug" element={<VisaByType />} />
                      <Route path="visa/details/:slug" element={<VisaDetails />} />
                      <Route path="contact-us" element={<Contact />} />
                      <Route path="faqs" element={<Faq />} />
                      <Route path="*" element={<NotFound />} />
                  </Route>
              </Routes>
          </BrowserRouter>
          <ScrollToTopButton />
      </>

  );
}

export default App;
